import { Box, Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../global/components";
import { handleErrorMessage } from "../../../../helpers/methods";
import { getArudhaPadaData } from "../../AnalysisService";

interface CustomProps {
  profileId: string;
  setIsLoading: Function;
}

const getOrdinal = (n: number) => {
  const v = n % 100;
  if (v >= 11 && v <= 13) return `${n}th`;
  switch (v % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
};

function convertToDegreesMinutesSeconds(encodedString: string) {
  const element = document.createElement("div");
  element.innerHTML = encodedString;
  let visibleText = element.innerText;
  visibleText = visibleText.replace(/[^a-zA-Z0-9\s]/g, (match) => `${match} `);

  return visibleText;
}

const ArudhaPada = (props: CustomProps) => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<any[]>([]);

  const tableHeader = [
    {
      name: `${t("planet")}`,
      field: "planet",
    },
    {
      name: `${t("nakshatra")}`,
      field: "nakshatra",
    },
    {
      name: `${t("pada")}`,
      field: "pada",
    },
    {
      name: `${t("rasi")}`,
      field: "pada_sign",
    },
  ];

  useEffect(() => {
    getArudhaPadaDetails();
  }, [i18n.language]);

  const getArudhaPadaDetails = async () => {
    try {
      props.setIsLoading(true);
      const language = i18n.language.toLowerCase();
      const response = await getArudhaPadaData(props.profileId, language);
      const rows = Array.isArray(response) ? response : [];
      setData(
        rows.map((row: any) => ({
          ...row,
          planet: `${getOrdinal(Number(row.house_number) || 0)} House - ${row.arudha_name ?? ""}`,
          pada_sign: ` ${row.pada_sign} - ${convertToDegreesMinutesSeconds(row.pada_degree_dms)}`,
        })),
      );
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      props.setIsLoading(false);
    }
  };

  const getArudhaPada = () => {
    return (
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Box sx={{ overflowX: "auto" }}>
          <CustomTable
            headers={tableHeader}
            rows={data}
            isRowPerPageEnable={true}
            rowsPerPage={20}
          />
        </Box>
      </Container>
    );
  };

  return getArudhaPada();
};

export default ArudhaPada;
